import type { Locale } from 'date-fns';
import {
  az,
  de,
  enUS,
  es,
  fr,
  hi,
  it,
  pt,
  ptBR,
  ro,
  ru,
  tr,
  uk
} from 'date-fns/locale';

import LOCALES from 'constants/locales';

export const CALENDAR_LOCALE_MAP = {
  [LOCALES.ENGLISH_US]: enUS,
  [LOCALES.SPANISH_ES]: es,
  [LOCALES.SPANISH_LATAM]: es,
  [LOCALES.PORTUGUESE_BR]: ptBR,
  [LOCALES.PORTUGUESE_PT]: pt,
  [LOCALES.FRENCH_FR]: fr,
  [LOCALES.RUSSIAN_RU]: ru,
  [LOCALES.GERMAN_DE]: de,
  [LOCALES.HINDI_IN]: hi,
  [LOCALES.TURKISH_TR]: tr,
  [LOCALES.AZERBAIJANI_AZ]: az,
  [LOCALES.ROMANIAN_RO]: ro,
  [LOCALES.UKRAINIAN]: uk,
  [LOCALES.ITALIAN_IT]: it
} as const;

type CalendarLocaleKey = keyof typeof CALENDAR_LOCALE_MAP;

export const getDateFnsLocale = (language: string): Locale => {
  if (language in CALENDAR_LOCALE_MAP) {
    return CALENDAR_LOCALE_MAP[language as CalendarLocaleKey];
  }
  return CALENDAR_LOCALE_MAP[LOCALES.ENGLISH_US];
};
